export default {"src":"/portal/_next/static/media/sale-banner-green.7daa88d7.svg","height":113,"width":113,"blurWidth":0,"blurHeight":0};